import { CombinedGraphQLErrors, ServerError, ServerParseError } from "@apollo/client/errors";
import { print as printGraphQL } from "graphql/language/printer";
import { get } from "lodash-es";

import ExtendedError from "./ExtendedError";

export default function getApolloErrors(apolloError) {
  const operation = apolloError.operation && {
    query: printGraphQL(apolloError.operation.query),
    variables: apolloError.operation.variables,
  };

  const errors = [];

  // apollo client 4 wraps the GraphQL errors, older versions put them on graphQLErrors
  const graphQLErrors = CombinedGraphQLErrors.is(apolloError) ? apolloError.errors : apolloError.graphQLErrors || [];
  for (const graphQLError of graphQLErrors) {
    const path = get(graphQLError, "path") || [];
    const extensions = get(graphQLError, "extensions");

    errors.push(
      new ExtendedError(graphQLError.message, {
        apolloErrorType: "GraphQLError",
        operation,
        path: path.join(" -> "),
        ...extensions,
      }),
    );
  }

  const networkError =
    ServerError.is(apolloError) || ServerParseError.is(apolloError) ? apolloError : apolloError.networkError;
  if (networkError) {
    const { statusCode, bodyText, name, message } = networkError;
    errors.push(
      new ExtendedError(message, {
        apolloErrorType: "NetworkError",
        operation,
        statusCode,
        bodyText,
        errorName: name,
      }),
    );
  }

  // never leave the caller with nothing to show
  if (errors.length === 0 && apolloError.message) {
    errors.push(new ExtendedError(apolloError.message, { apolloErrorType: "Error", operation }));
  }

  return errors;
}
